import { useState, useContext, useEffect } from "react";
import { FornecedoresContext } from "../../../contexts/fornecedoresProvider";
import Marca from "../Marca";
import Modelo from "../Modelo";

const MarcaModelo = () => {
  const { fornecedores } = useContext(FornecedoresContext);
  const [newfornecedores, setNewfornecedores] = useState([]);
  const [fornecedor, setFornecedor] = useState(null);
  const [marca, setMarca] = useState(null);
  const [modelo, setModelo] = useState(null);

  useEffect(() => {
    let newFornc = fornecedores ? [...fornecedores] : [];
    setNewfornecedores(newFornc);
  }, [fornecedores]);

  const handleSelectFornecedor = (e) => {
    const value = e.target.value;
    const fornecedorSelecionado = newfornecedores.find((f) => f.id === parseInt(value));
    setFornecedor(fornecedorSelecionado);
  };

  return (
    <div className="space-y-6">
      {/* Fornecedor Selection */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
          Selecione o Fornecedor
        </h2>
        <div className="space-y-2" data-tour-id="marca-modelo:fornecedor">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Fornecedor
          </label>
          <select
            className="w-full px-4 py-3 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-900 dark:text-white focus:ring-2 focus:ring-vox-blue-500 focus:border-vox-blue-500 transition-colors duration-200"
            onChange={handleSelectFornecedor}
          >
            <option value="">Selecione o fornecedor</option>
            {newfornecedores &&
              newfornecedores
                .slice()
                .sort((a, b) => a.nome.localeCompare(b.nome))
                .map((fornecedor, index) => (
                  <option key={index} value={fornecedor.id}>
                    {fornecedor.nome}
                  </option>
                ))}
          </select>
        </div>
      </div>

      {/* Marca Section */}
      {fornecedor && (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
            Gerenciar Marcas - {fornecedor.nome}
          </h3>
          <Marca fornecedor={fornecedor} setMarca={setMarca} />
        </div>
      )}

      {/* Modelo Section */}
      {marca && (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
            Gerenciar Modelos - {marca.nome}
          </h3>
          <Modelo fornecedor={fornecedor} marca={marca} setModelo={setModelo} />
        </div>
      )}
    </div>
  );
};

export default MarcaModelo;
